import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const GET_EXISTING_ACCOUNTS_KEY = 'GET_EXISTING_ACCOUNTS_KEY';

const useGetExistingAccountsQuery = (accountsIds?: string[]) => {
  const ids = useMemo(() => accountsIds?.map((id) => toNumber(id)), [accountsIds]);
  const { isLoading, isSuccess, data } = useQuery(
    [GET_EXISTING_ACCOUNTS_KEY, ids],
    () =>
      api.get(API_URL.ACCOUNTS_BATCH, {
        params: {
          ids,
        },
      }),
    {
      enabled: Boolean(accountsIds?.length),
    }
  );

  const hasBalance = useMemo(
    () => data?.data?.some((item) => item?.live_balance && item.live_balance > 0),
    [data]
  );

  return {
    isLoading,
    isSuccess,
    hasBalance,
  };
};

export default useGetExistingAccountsQuery;
